import React from 'react';
import { Trans } from '@lingui/macro';
import { useModalContext } from '../../../hooks/useModal';
import { CollateralType } from '../../../helpers/types';
import { AlertBanner } from '../../../ui-kit/AlertBanner';
import { PositionModalWrapperProps } from '../FlowCommons/PositionModalWrapper';
import { ScrollModalContent, ScrollModalFooter } from '../../../components/primitives/ScrollModal';
import { DetailsCollateralLine, DetailsNumberLine, TxModalDetails } from '../FlowCommons/TxModalDetails';
import { TxPositionDetails } from '../FlowCommons/TxPositionDetails';
import { TxSuccessView } from '../FlowCommons/Success';
import { WithdrawPositionActions } from './WithdrawPositionActions';

export const WithdrawPositionModalContent = React.memo(
  ({ isWrongNetwork, enrichedPosition, suppliedTokenId }: PositionModalWrapperProps) => {
    const { gasLimit, txError, mainTxState, setTxError } = useModalContext();

    const withdrawPositionActionsProps = {
      marketId: enrichedPosition.marketId,
      isWrongNetwork,
      suppliedTokenId,
    }

    if (mainTxState.success)
      return (
        <ScrollModalContent>
          <TxSuccessView
            action={<Trans>withdrew position</Trans>}
            amount={enrichedPosition.marketReferenceCurrencyValue.toString()}
            symbol={`${enrichedPosition.token0.symbol} / ${enrichedPosition.token1.symbol}`}
          />
        </ScrollModalContent>
      );

    return enrichedPosition ? (
      <>
        <ScrollModalContent>
          <TxPositionDetails token0={enrichedPosition.token0} token1={enrichedPosition.token1} />
          <TxModalDetails gasLimit={gasLimit} skipLoad={true}>
            <DetailsNumberLine
              description={<Trans>Total liquidity to withdraw</Trans>}
              value={enrichedPosition.marketReferenceCurrencyValue}
              numberPrefix='$'
            />
            <DetailsNumberLine
              description={<Trans>Fees earned</Trans>}
              value={
                enrichedPosition.token0.marketReferenceCurrencyFee + enrichedPosition.token1.marketReferenceCurrencyFee
              }
              numberPrefix='$'
            />
            <DetailsCollateralLine collateralType={CollateralType.ENABLED} />
          </TxModalDetails>

          {txError && (
            <AlertBanner variant="error" txError={txError} onClose={() => setTxError(undefined)} />
          )}

        </ScrollModalContent>

        <ScrollModalFooter>
          <WithdrawPositionActions {...withdrawPositionActionsProps} />
        </ScrollModalFooter>
      </>
    ) : null;
  }
);
